import React, { useEffect } from 'react';
import { getCSSCustomProperties } from '../../utils/brandingUtils';

export const BrandingProvider = ({ children }) => {
    useEffect(() => {
        // Apply custom CSS properties to the document root
        const customProperties = getCSSCustomProperties();
        const root = document.documentElement;
        
        Object.entries(customProperties).forEach(([property, value]) => {
            root.style.setProperty(property, value);
        });
        
        // Update page title based on branding
        const { getAppConfig } = require('../../utils/brandingUtils');
        const appConfig = getAppConfig();
        if (appConfig.title) {
            document.title = appConfig.title;
        }
        
        // Update favicon based on branding
        const { getImages } = require('../../utils/brandingUtils');
        const images = getImages();
        if (images.favicon) {
            const favicon = document.querySelector('link[rel="icon"]') || 
                           document.querySelector('link[rel="shortcut icon"]');
            if (favicon) {
                favicon.href = images.favicon;
            } else {
                const newFavicon = document.createElement('link');
                newFavicon.rel = 'icon';
                newFavicon.href = images.favicon;
                document.head.appendChild(newFavicon);
            }
        }
        
        // Update apple touch icon based on branding
        if (images.appleTouchIcon) {
            let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
            if (appleTouchIcon) {
                appleTouchIcon.href = images.appleTouchIcon;
            } else {
                appleTouchIcon = document.createElement('link');
                appleTouchIcon.rel = 'apple-touch-icon';
                appleTouchIcon.href = images.appleTouchIcon;
                document.head.appendChild(appleTouchIcon);
            }
        }
        
        // Update manifest theme color
        const manifest = document.querySelector('link[rel="manifest"]');
        if (manifest) {
            // Note: In a real implementation, you might want to dynamically generate the manifest
            // based on the current branding configuration
        }
        
    }, []);

    return <>{children}</>;
}; 